import { LockOutlined, Visibility, VisibilityOff } from '@mui/icons-material';
import { Avatar, Box, Button, CardContent, CardHeader, CssBaseline, Grid, IconButton, InputAdornment, LinearProgress, Paper, TextField, Typography, Card, InputLabel } from '@mui/material';
import { Navigate, Route, Routes, useLocation, useNavigate, } from 'react-router-dom';
import React, { useContext, useEffect, useState } from 'react';
import Grid2 from '@mui/material/Grid2';
import proxelera from '../../images/proxelera.png';
import { commons } from '../../commons';
import { formToObj, validateFormData } from '../../lib/validator';
import AuthService from '../../service/AuthService';
import background from "../../images/background.jpg"
import background1 from "../../images/background1.jpg"
import { customStyles } from "../../styles/tableStyle"
import Project from "../DashBoard/Project"
import { toast } from 'react-toastify';

let loginSchema = [
    {
        key: 'email',
        value: '',
        error: '',
        required: true,
        type: 'text',
        label: 'Email',
        displayName: 'Email'
    },
    {
        key: 'password',
        value: '',
        error: '',
        required: true,
        type: 'password',
        label: 'Password',
        displayName: 'Password'
    },
];

function Login(props) {
    const navigate = useNavigate();
    const [loginData, setLoginData] = useState([]);
    const [showPwd, setShowPwd] = useState(false);
    const [loading, setLoading] = useState(false);
    const [userLogin, setUserLogin] = useState(false);

    useEffect(() => {
        AuthService.getUserInfo() != null ?
            navigate("/dashboard") :
            loadForm();
        if (AuthService.getUserInfo() && localStorage.getItem("projectId") == null) {
            const handlePopState = (event) => {
                navigate(1);
            };

            window.addEventListener("popstate", handlePopState);

            return () => {
                window.removeEventListener("popstate", handlePopState);
            };
        }

    }, [navigate]);

    const handleKeyDown = (event, key) => {
        if (event.key === 'Enter') {
            handleLogin(event, key);
        }
    };

    const loadForm = async () => {
        let loginSchemaData = [...loginSchema];
        setLoginData(loginSchemaData);
    };
    const redirectToDashBoard = () => {
        navigate('/dashboard');

    }
    const handleLogin = async (event) => {
        event.preventDefault();
        setLoading(true);
        let loginContent = [...loginData];
        let validFormData = await validateFormData(loginContent);
        setLoginData(validFormData)
        let result = validFormData.find(item => {
            if (item.error.length) return item;
        });

        if (!result) {
            let params = await formToObj(validFormData);
            params.op = "login"
            commons.getAPIRes(params, "POST", "login").then(userRes => {
                setLoading(false)
                if (userRes.status) {
                    localStorage.setItem("userInfo", JSON.stringify(userRes.result));
                    localStorage.setItem("token", userRes.result.token);
                    localStorage.setItem("login", true);
                    localStorage.setItem("role",userRes.result.role)

                    AuthService.setUserInfo(userRes.result)
                    setUserLogin(true)

                    toast.success("Login successful!");
                }
                else {
                    toast.error("Invalid credentials");
                }
            }).catch(error => {
                setLoading(false);
                toast.error("Login failed. Please try again.");
            });
        } else {
            setLoading(false);
        }
    };

    const renderDashBoard = () => {
        props.history.push('/ticket-list')
    };

    const redirectRegister = () => {
        navigate("/register")
    }
    const redirectForgotPassword = () => {
        navigate("/forgotPassword")
    }
    const handleChange = (e, key) => {
        const newValue = e.target.value;
        setLoginData((prevData) =>
            prevData.map((item) =>
                item.key === key
                    ? { ...item, value: newValue, error: '' }
                    : item
            )
        );
    };

    return (
        <Grid2 container spacing={2} sx={{
            justifyContent: "center",
            alignItems: "center",
            backgroundImage: `url(${background})`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            width: '100vw',
            height: '100vh'
        }} >
            <CssBaseline />
            <Grid2 xs={12} md={6} lg={4} sx={{ 
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: 500 
            }}>
                <Paper elevation={3} sx={{ 
                    width: '100%',
                    maxWidth: 500,
                    margin: 2,
                    borderRadius: 2
                }}>
                    <Box sx={{ 
                        padding: { xs: 2, sm: 3, md: 4 },
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center'
                    }}>
                        {loading && <LinearProgress sx={{ width: '100%'}} />}
                        {/* <Box
                            component="img"
                            sx={{
                                height: { xs: 150, sm: 200, md: 233 },
                                width: { xs: 250, sm: 300, md: 350 },
                                maxHeight: { xs: 150, sm: 200, md: 233 },
                                maxWidth: { xs: 250, sm: 300, md: 350 },
                                marginBottom: 2
                            }}
                            alt="The house from the offer."
                            src={proxelera}
                        /> */}
                        {!userLogin ? (
                            <>
                            <Typography variant='h5' style={{ marginBottom: 20 ,fontWeight: 'bold' }}>Login</Typography> 
                                {loginData.map((item, index) => (
                                    <TextField
                                        sx={{ m: 1, width: '100%' }}
                                        key={index}
                                        type={item.type == "password" ? (showPwd ? "text" : item.type) : item.type}
                                        label={item.label}
                                        fullWidth
                                        required
                                        value={item.value}
                                        onKeyDown={(e) => handleKeyDown(e, item.key)}
                                        onChange={(e) => handleChange(e, item.key)}
                                        error={!!item.error}
                                        helperText={item.error}
                                        slotProps={{
                                            input: {
                                                endAdornment: item.type === "password" && (
                                                    <InputAdornment position="end">
                                                        <IconButton onClick={() => setShowPwd(!showPwd)} >
                                                            {showPwd ? (<Visibility />) : (<VisibilityOff />)}
                                                        </IconButton>
                                                    </InputAdornment>
                                                ),
                                            }
                                        }}
                                    />
                                ))}
                                {/* Forgot Password link should only be as wide as the text */}
                                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                                    <Typography 
                                        style={{ ...customStyles.hyperlink, cursor: 'pointer' }}
                                        variant='subtitle2'
                                        onClick={redirectForgotPassword}
                                    >
                                        Forgot Password?
                                    </Typography>
                                </Box>

                                <Button
                                    type="Submit"
                                    color="secondary"
                                    variant="contained"
                                    fullWidth
                                    onClick={handleLogin}
                                    disabled={loading}
                                    style={{ ...customStyles.submitBtn, width: 'fit-content', marginTop: 2 }}
                                >
                                    Login
                                </Button>
                                <div style={{
                                    display: 'flex', 
                                    flexDirection: 'row',
                                    justifyContent: 'center', 
                                    alignItems: 'center',
                                    marginTop: 20,
                                    width: '100%'
                                }}>
                                    <Typography variant='caption'>Don't have an account ? &nbsp;</Typography>
                                    <Typography 
                                        style={{ ...customStyles.hyperlink, cursor: 'pointer' }}
                                        variant='subtitle1'
                                        onClick={redirectRegister}
                                    >
                                        Register here
                                    </Typography>
                                </div>
                            </>
                        ) : (
                            <>
                                <Typography variant='h6' style={{ marginBottom: 50 }}>{"Welcome " + AuthService.getUserInfo().name}</Typography>


                                <Project disabled={false} />
                                <Button
                                    type="Submit"
                                    color="secondary"
                                    variant="contained"
                                    fullWidth
                                    onClick={redirectToDashBoard}
                                    disabled={loading}
                                    style={{ ...customStyles.submitBtn, width: 'fit-content' }}

                                >
                                    Continue
                                </Button>
                            </>
                        )}
                    </Box>
                </Paper>
            </Grid2>
        </Grid2>
    );
}

export default Login;
